// Build a breadcrumb that only shows first-level entries:
// /                     -> Home
// /show                 -> Home / Show
// /show/:id             -> Home / Show / :id
// /myUploads/:id        -> Home / My Uploads / :id
// /form (and children)  -> Home / Form (stop, no subroutes)
export function buildTopLevelBreadcrumbs(route) {
  const items = [];

  // Always start with Home
  items.push({
    label: "Home",
    to: { name: "HomePage" }, // matches your routes config
  });

  const path = route.path || "/";
  const segments = path.split("/").filter(Boolean); // ['show', '123', 'extra', ...]

  if (segments.length === 0) {
    return items; // Home only
  }

  const first = segments[0];

  if (first === "show") {
    // /show
    items.push({
      label: "Show",
      to: { name: "showList" },
    });

    // /show/:id — include the id, but no deeper levels
    const id = route.params?.investigation_id;
    if (id) {
      items.push({
        label: String(id),
        to: { name: "showDataset", params: { investigation_id: id } },
      });
    }
    return items;
  }

  if (first === "myUploads") {
    // /myUploads
    items.push({
      label: "My Uploads",
      to: { name: "MyUploads" },
    });

    // /myUploads/:id (and deeper, e.g. /dataset/new) — include the id only
    const id = route.params?.investigation_id;
    if (id) {
      items.push({
        label: String(id),
        to: { name: "myUploadDataset", params: { investigation_id: id } },
      });
    }
    return items;
  }

  if (first === "form") {
    // /form and ANY children => stop at /form
    items.push({
      label: "Form",
      to: { name: "FormPage" },
    });
    return items;
  }

  if (first === "admin") {
    // /admin
    items.push({
      label: "Admin",
      to: { name: "AdminDashboard" },
    });

    // /admin/logs
    if (segments.length > 1 && segments[1] === "logs") {
      items.push({
        label: "Logs",
        to: { name: "AdminLogs" },
      });
    }
    return items;
  }

  // Unknown top-level: just show the first segment capitalized (optional)
  items.push({
    label: capitalize(first),
    to: routeToFirstSegment(first),
  });

  return items;
}

function routeToFirstSegment(first) {
  // Make a tolerant "to" for unknown sections; adjust if you add more named routes.
  try {
    switch (first) {
      case "show":
        return { name: "showList" };
      case "form":
        return { name: "FormPage" };
      case "admin":
        return { name: "AdminDashboard" };
      default:
        return { path: `/${first}` };
    }
  } catch {
    return { path: `/${first}` };
  }
}

function capitalize(s = "") {
  return s.charAt(0).toUpperCase() + s.slice(1);
}
